// @flow
import type {
  AncillaryStandardSegment,
  CoverMoreSegment,
  FastTrackSegment,
} from "booking/services/ancillaries3rd/services/types"

export const isSegmentApplicableMapper = (
  data: CoverMoreSegment | AncillaryStandardSegment | FastTrackSegment,
): boolean => data.is_applicable
